import jwt from 'jsonwebtoken'
import { PublicKey } from './PublicKey';

export class SSE {
    static listen(url, listenerFunction) {
        try {
            const eventSource = new EventSource(url);
            eventSource.onmessage = (e) => {
                try {
                    if (e.data) {
                        const message = JSON.parse(e.data);
                        const payload = jwt.verify(message.message, PublicKey, {
                            algorithms: ['RS256'],
                        });

                        listenerFunction(payload);
                    }
                } catch (err) {
                    console.log(err)
                }
            };
            return true;
        } catch (err) {
            console.log({ err })
        }
    }
}